"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const dymo_core_1 = require("dymo-core");
class Navigator {
    constructor(dymoUri, store) {
        this.dymoUri = dymoUri;
        this.store = store;
        this.playCount = 0;
        this.store.addPartsObserver(dymoUri, this);
    }
    hasParts() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.parts) {
                yield this.updateParts();
            }
            return this.parts.length > 0;
        });
    }
    next() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.parts) {
                yield this.updateParts();
            }
            return undefined;
        });
    }
    keepPlaying() {
        return __awaiter(this, void 0, void 0, function* () {
            let keepPlaying = !this.playCount || (yield this.isLoop())
                || (yield this.repetitions()) > this.playCount;
            return keepPlaying;
        });
    }
    isLoop() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.store.findParameterValue(this.dymoUri, dymo_core_1.uris.LOOP)) || false;
        });
    }
    repetitions() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.store.findParameterValue(this.dymoUri, dymo_core_1.uris.REPEAT)) || 0;
        });
    }
    toArray(s) {
        return s ? [s] : undefined;
    }
    observedPartsChanged(dymoUri) {
        if (dymoUri == this.dymoUri) {
            this.updateParts();
        }
    }
    updateParts() {
        return __awaiter(this, void 0, void 0, function* () {
            this.parts = yield this.store.findParts(this.dymoUri);
        });
    }
}
exports.Navigator = Navigator;
class IndexedNavigator extends Navigator {
    constructor(dymoUri, store) {
        super(dymoUri, store);
        this.reset();
    }
    next() {
        const _super = name => super[name];
        return __awaiter(this, void 0, void 0, function* () {
            yield _super("next").call(this);
            //check if another pass appropriate
            if (this.currentIndex == this.parts.length && (yield this.keepPlaying())) {
                this.reset();
            }
            //first next of pass
            if (this.currentIndex == 0) {
                this.playCount++;
            }
            return this.get();
        });
    }
    getPosition() {
        return this.currentIndex;
    }
    /** override for any non-index-based reset operation */
    reset() {
        this.currentIndex = 0;
    }
}
exports.IndexedNavigator = IndexedNavigator;
class SequentialNavigator extends IndexedNavigator {
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            return { uris: this.toArray(this.parts[this.currentIndex++]) };
        });
    }
}
exports.SequentialNavigator = SequentialNavigator;
class ReverseSequentialNavigator extends IndexedNavigator {
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            let reverseIndex = this.parts.length - 1 - this.currentIndex++;
            return { uris: this.toArray(this.parts[reverseIndex]) };
        });
    }
}
exports.ReverseSequentialNavigator = ReverseSequentialNavigator;
class PermutationNavigator extends IndexedNavigator {
    reset() {
        super.reset();
        this.permutedIndices = _.shuffle(_.range(this.parts.length));
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                uris: this.toArray(this.parts[this.permutedIndices[this.currentIndex++]])
            };
        });
    }
}
exports.PermutationNavigator = PermutationNavigator;
class OnsetNavigator extends SequentialNavigator {
    get() {
        const _super = name => super[name];
        return __awaiter(this, void 0, void 0, function* () {
            const init = this.currentIndex === 0;
            yield this.sortParts();
            const superget = yield _super("get").call(this);
            return { uris: superget.uris, initRefTime: init };
        });
    }
    sortParts() {
        return __awaiter(this, void 0, void 0, function* () {
            //sort parts by ONSET if not currently sorted
            //TODO: now this could also observe if the onsets change...
            const onsets = yield Promise.all(this.parts.map(p => this.getOnset(p)));
            const sorted = onsets.every((o, i) => i == 0 || o >= onsets[i - 1]);
            if (!sorted) {
                this.parts = _.sortBy(this.parts, p => onsets[this.parts.indexOf(p)]);
            }
        });
    }
    getOnset(dymoUri) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.store.findParameterValue(dymoUri, dymo_core_1.uris.ONSET);
        });
    }
}
exports.OnsetNavigator = OnsetNavigator;
class OneshotNavigator extends Navigator {
    next() {
        const _super = name => super[name];
        return __awaiter(this, void 0, void 0, function* () {
            yield _super("next").call(this);
            if (yield this.keepPlaying()) {
                this.playCount++;
                return Promise.resolve(this.get());
            }
        });
    }
}
exports.OneshotNavigator = OneshotNavigator;
class LeafNavigator extends OneshotNavigator {
    get() {
        return { uris: this.toArray(this.dymoUri) };
    }
    getPosition() {
        return 0;
    }
}
exports.LeafNavigator = LeafNavigator;
class ConjunctionNavigator extends OneshotNavigator {
    get() {
        return { uris: this.parts };
    }
    getPosition() {
        return 0;
    }
}
exports.ConjunctionNavigator = ConjunctionNavigator;
class DisjunctionNavigator extends OneshotNavigator {
    get() {
        return { uris: this.toArray(this.parts[_.random(this.parts.length)]) };
    }
    getPosition() {
        return 0;
    }
}
exports.DisjunctionNavigator = DisjunctionNavigator;
function getNavigator(dymoUri, store) {
    return __awaiter(this, void 0, void 0, function* () {
        let dymoType = yield store.findObject(dymoUri, dymo_core_1.uris.CDT);
        let parts = yield store.findParts(dymoUri);
        if (dymoType === dymo_core_1.uris.CONJUNCTION) {
            return new ConjunctionNavigator(dymoUri, store);
        }
        else if (dymoType === dymo_core_1.uris.DISJUNCTION) {
            return new DisjunctionNavigator(dymoUri, store);
        }
        else if (parts.length > 0) {
            if ((yield store.findParameterValue(parts[0], dymo_core_1.uris.ONSET)) != null) {
                return new OnsetNavigator(dymoUri, store);
            }
            return new SequentialNavigator(dymoUri, store);
        }
        else {
            return new LeafNavigator(dymoUri, store);
        }
    });
}
exports.getNavigator = getNavigator;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-player/lib/navigators.js
// module id = 1315
// module chunks = 3